<div class="u-height-100" fxLayout="column">
  <div class="u-overflow-auto u-showScrollBar u-padding-24" fxFlex="100%">
    <app-program-participant-preferences-form
      [formControl]="programPreferencesFormControl"
      [group]="group"
      [program]="program"
      [programAccounts]="programAccounts"
      [user]="user"
      [userProgramMembership]="programMembership"
    ></app-program-participant-preferences-form>
  </div>
  <div
    class="u-padding-8-0 u-padding-0-16 u-borderTop-grey100"
    fxFlex="0 0 auto"
    fxLayoutAlign="end center"
    fxLayoutGap="8px"
  >
    <button
      (click)="drawerRef.close()"
      mat-button
      type="button"
      i18n="@@global.cancel"
    >
      Cancel
    </button>
    <button
      [disabled]="isLoading || !programPreferencesFormControl.valid"
      (click)="saveParticipantPreferences()"
      color="primary"
      mat-raised-button
    >
      <span i18n="@@global.save">Save</span>
      @if (isLoading) {
        <i
          class="u-marginLeft-8"
          nz-icon
          nzSpin
          nzTheme="outline"
          nzType="sync"
        ></i>
      }
    </button>
  </div>
</div>
